const VERSION_QUERY_KEYS = ["version", "landingVersion"];

export function getLandingVersion(query = {}) {
  for (const key of VERSION_QUERY_KEYS) {
    const value =
      typeof query[key] === "string" ? query[key].toUpperCase() : "";
    if (value === "A" || value === "B") {
      return value;
    }
  }
  return Math.random() < 0.5 ? "A" : "B";
}

export function getChannelQuery(query = {}) {
  return Object.keys(query).reduce((channel, key) => {
    if (!VERSION_QUERY_KEYS.includes(key)) {
      channel[key] = query[key];
    }
    return channel;
  }, {});
}

export function getVersionedLandingUrl(href, version) {
  const url = new URL(href);
  url.searchParams.set("version", version);
  return url.toString();
}
